<template>
  <div>
    <div class="profile-header">
      <div class="profile-header-content container">
        <img src="../assets/images/profile.png" height="100px" style="margin-right: 1.2rem">

        <div class="profile-header-info">
          <div class="profile-header-info__user-data"
               v-if="userData.firstName || userData.lastName">
            <h3 class="user-name">{{userData.firstName}} {{userData.lastName}}</h3>

            <h6 class="email" v-if="userData.email">{{userData.email}}</h6>
          </div>
          <skeleton-box width="190px" display="block" height="39px" v-else
                        style="margin-bottom: 25px;"></skeleton-box>
          <button class="btn btn-blue btn-sm" v-on:click="signOut">Sign out</button>
        </div>
      </div>
    </div>
    <profile-top></profile-top>
    <div class="content">
      <courses></courses>
    </div>
  </div>
</template>

<script>
    import {AUTH_LOGOUT, GET_USER_DATA} from "../store/actions/auth";
    import {COURSE_REQUEST, GET_USER_COURSE_DATA} from "../store/actions/course";
    import Courses from "../components/Courses";
    import {mapState} from "vuex";
    import userData from "../store/modules/userData";
    import SkeletonBox from "../components/SkeletonBox";
    import ProfileTop from "../components/ProfileTop";

    export default {
        name: "Profile",
        components: {ProfileTop, Courses, SkeletonBox},
        data() {
            return {
                userData: {
                    firstName: '',
                    lastName: ''
                },
                courses: [],

            }
        },
        created() {
            this.prepareData(this.$store.getters.getCourses, this.$store.getters.getCurrentUserData);

            this.$store.dispatch(GET_USER_DATA, localStorage.currentUserId);
            this.$store.dispatch(COURSE_REQUEST);
        },
        mounted() {
            this.$store.watch(
                (state, getters) => getters.getCourses,
                (courses) => {
                    this.courses = courses;
                },
            );

            this.$store.watch(
                (state, getters) => getters.getCurrentUserData,
                (userData) => {
                    this.userData = userData;
                },
            );
        },
        methods: {
            prepareData(courses, userData) {
                this.courses = courses;
                this.userData = userData;
            },
            signOut() {
                this.$store.dispatch(AUTH_LOGOUT).then(() => {
                    this.$router.push('/')
                });
            }
        },
    }
</script>

<style scoped>

</style>
